




























import Vue from 'vue';
import Cookies from 'js-cookie';

interface Data {
  sessionTimeout: boolean;
  showSignInAgain: boolean;
}

export default Vue.extend({
  name: 'LoggedOut',
  data(): Data {
    return {
      sessionTimeout: true,
      showSignInAgain: true,
    };
  },
  mounted() {
    const urlToken = this.getUrlParameter('signed_out');
    const federatedSignOut = this.getUrlParameter('federated_sign_out');

    if (urlToken !== '') {
      this.sessionTimeout = false;
    }
    if (federatedSignOut !== '' || Cookies.get('federatedSignIn')) {
      this.showSignInAgain = false;
      Cookies.remove('federatedSignIn');
    }
  },
  methods: {
    getUrlParameter(name): string {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      const results = regex.exec(location.search);
      return results === null
        ? ''
        : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
  },
});
